import React from "react";
import { connect } from "react-redux";
import redux from "redux";

import { MainMenuItem } from "./MainMenuItem";
import { TreeBranch } from "../../models/navigation";
import { AppState } from "../../store";
import { List } from "immutable";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    childOfPath: state.nav.childOfPath,
    navItems: state.nav.branches,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
});

interface OwnProps {
}

interface ConnectedState {
    childOfPath?: string;
    navItems: List<TreeBranch | undefined>;
}

interface ConnectedDispatch {
}

interface OwnState {
}

export class MainMenuComponent extends React.Component<ConnectedState & ConnectedDispatch & OwnProps, OwnState> {

    public render() {
        const home = this.props.navItems.find((b) => b !== undefined && !b.parentIds.length);
        if (!home)
            return null;

        let children = this.props.navItems.filter((b) => {
            return b !== undefined && b.onNav && home.childIds.indexOf(b.id) > -1;
        }).toList();

        children = children.push(home)
            .sortBy((b) => b !== undefined && b.sort)
            .toList();

        const navItems = children.map((item, i) => {
            if (!item || !item.onNav)
                return null;

            return <MainMenuItem
                active={item.url === home.url ? false : (item.active || item.url === this.props.childOfPath)}
                id={item.id}
                key={item.id}
                separator={item.separator}
                title={item.title}
                url={item.url}
            />;
        });

        return <div id="nav">
            <ul>
                {navItems}
            </ul>
        </div>;
    }
}

export const MainMenu: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(MainMenuComponent);



// WEBPACK FOOTER //
// ./src/components/navigation/MainMenu.tsx